import {
  Typography,
  Stack,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Close from "@mui/icons-material/Close";
import { useAppDispatch, useAppSelector } from "context/hooks";
import { selectDiffViewer } from "context/modal.selector";
import { setDiffViewer } from "context/modal.context";
import { diffJson } from "diff";
import DashedDivider from "../DashedDivider";

export default function DiffViewer() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const props = useAppSelector(selectDiffViewer);
  let left = [];
  let right = [];
  if (props.open) {
    const diff = diffJson(
      props.data?.oldValue ?? "",
      props.data?.newValue ?? ""
    );

    diff.forEach((part, index) => {
      if (part.added) {
        right.push({ id: index, color: "green", value: part.value });
      } else if (part.removed) {
        left.push({ id: index, color: "red", value: part.value });
      } else {
        left.push({ id: index, color: "grey", value: part.value });
        right.push({ id: index, color: "grey", value: part.value });
      }
    });
  }
  const dismiss = () => {
    dispatch(setDiffViewer({ open: false, data: props.data }));
  };
  return (
    <Dialog open={props.open} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <Typography
              color="gray.main"
              variant="h6"
              fontWeight="medium"
              alignSelf="center"
            >
              {t("diffViewer.compareValues")}
            </Typography>
          </Stack>
          <IconButton onClick={dismiss}>
            <Close />
          </IconButton>
        </Stack>
        <DashedDivider />
      </DialogTitle>
      <DialogContent sx={{ py: 1 }} className="custom-scrollbar">
        <Grid container sx={{ border: "1px solid gray" }}>
          <Grid
            container
            item
            justifyContent="center"
            xs={6}
            sx={{ border: "1px solid gray" }}
          >
            <Typography
              color="error.main"
              variant="subtitle1"
              fontWeight="medium"
              alignSelf="center"
              margin={1}
            >
              {t("diffViewer.oldValue")}
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={6}
            justifyContent="center"
            sx={{ border: "1px solid gray" }}
          >
            <Typography
              color="success.light"
              variant="subtitle1"
              fontWeight="medium"
              alignSelf="center"
            >
              {t("diffViewer.newValue")}
            </Typography>
          </Grid>
          <Grid container item xs={6} sx={{ border: "1px solid gray" }}>
            <Typography
              component="pre"
              sx={{
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                paddingLeft: 1
              }}
            >
              {left.map((part) => {
                return (
                  <Typography
                    component="code"
                    variant="caption"
                    key={part.id}
                    color={part.color}
                  >
                    {part.value}
                  </Typography>
                );
              })}
            </Typography>
          </Grid>
          <Grid
            container
            item
            xs={6}
            sx={{ border: "1px solid gray", wordWrap: "break-word" }}
          >
            <Typography
              component="pre"
              sx={{
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                paddingLeft: 1
              }}
            >
              {right.map((part) => {
                return (
                  <Typography
                    component="code"
                    variant="caption"
                    key={part.id}
                    color={part.color}
                  >
                    {part.value}
                  </Typography>
                );
              })}
            </Typography>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" marginTop={1}>
          <Button
            size="large"
            variant="outlined"
            color="gray"
            onClick={dismiss}
          >
            {t("common.cancel")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
